import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CLOSE_DELAY = 300; // ms
const OPEN_DELAY = 50; // ms

export type ModalState = ReturnType<typeof useModal>;

export const useModal = (isOpen: boolean = false, cookiesKeyModal?: string) => {
  const cookiesIsShownModal = Cookies.get(cookiesKeyModal);

  const [isVisible, setIsVisible] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(
    cookiesIsShownModal !== "false" && isOpen
  );

  const closeModal = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsOpenModal(false);
      if (cookiesKeyModal) Cookies.set(cookiesKeyModal, "false");
    }, CLOSE_DELAY);
  };

  const openModal = () => setIsOpenModal(true);

  useEffect(() => {
    if (isOpenModal) setTimeout(() => setIsVisible(true), OPEN_DELAY);
  }, [isOpenModal]);

  return { isOpenModal, isVisible, openModal, closeModal };
};
